<div>
    <div>
        <h2> Your products </h2>
        <div class="subheading">
            <global-home-badge [packageName]="packageName"></global-home-badge>
            <span class="text-dark text-size-m"> Boost your social strategy, engage with customers and measure the impact</span>
        </div>
    </div>
    <global-home-my-products [myProductList]="myProducts" [consumerResearchUrl]="consumerResearchUrl" [environment]="environment">
    </global-home-my-products>
</div>
<div *ngIf="exploreProducts && exploreProducts.length > 0">
    <div style="padding-top:48px">
        <h3> Explore other Brandwatch products </h3>
        <span class="text-dark text-size-m"> Research the content that resonates most with your audiences to create impactful campaigns </span>
    </div>
    <global-home-explore-products [exploreProductList]="exploreProducts">
    </global-home-explore-products>
</div>
